import { useLoaderData } from "@remix-run/react";
import { json } from "@remix-run/node";
//@ts-ignore
import type { LoaderFunction, V2_MetaFunction } from "@remix-run/node";
// import { GetScreenSize } from "~/utils";
import { ThemenList } from "~/shared";
import type { IThematicFoci } from "~/api/get_themenschwerpunkte_data.server";
import { fetchThemenschwerpunkteListItem } from "~/api";
import lpOgImage from "~/assets/images/og_image.jpg";

export const loader: LoaderFunction = async ({ context, request }) => {
  //   const url = new URL(request.url);

  const { data } = await fetchThemenschwerpunkteListItem();
  const { thematicFoci } = data;

  return json(
    {
      thematicFoci,
    },
    {
      headers: {
        // max-age controls the browser cache
        // s-maxage controls a CDN cache
        "Cache-Control": "public, max-age=30, s-maxage=86400",
      },
    }
  );
};
export const meta: V2_MetaFunction<typeof loader> = ({ data }) => {
  // console.log("========data methode", data);
  return [
    { title: "Themenschwerpunkte" },
    {
      property: "og:title",
      content: "Themenschwerpunkte",
    },
    {
      name: "description",
      content:
        "Redaktionell zusammengestellte Mediensammlungen zu aktuellen Themen aus Gesellschaft, Kirche, Politik, Kultur und dem kirchlichen Jahreskreis.",
    },
    { property: "og:image", content: lpOgImage },
  ];
};
export default function ThemenschwerpunkteIndex() {
  const { thematicFoci } =
    useLoaderData<{ thematicFoci: Array<IThematicFoci> }>();
  // const size = GetScreenSize();

  return (
    <div className="flex flex-col  px-3 md:px-0">
      <div className="section-wrapper mt-7">
        <h1 className="text-3xl text-textColor-light md:text-[64px]">
          Themenschwerpunkte
        </h1>
        <p className="text-textColor-ligh mt-10 max-w-6xl text-[18px]">
          Redaktionell zusammengestellte Mediensammlungen zu aktuellen Themen
          aus Gesellschaft, Kirche, Politik, Kultur und dem kirchlichen
          Jahreskreis.
        </p>
      </div>
      <ThemenList data={thematicFoci} />
      {/* <Outlet /> */}
    </div>
  );
}
